// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PostZendeskConfigsTicketAuthBody,
    BaseResponseZendeskConfigTicketFoundResponse,
} from '../../../types';

/**
 * auth
 *
 * @export
 * @tags zendesk-config-ticket-controller
 * @link [POST] /zendeskConfigs/ticket/auth
 */
export function postZendeskConfigsTicketAuth(
    data: PostZendeskConfigsTicketAuthBody
): Promise<BaseResponseZendeskConfigTicketFoundResponse>;
export function postZendeskConfigsTicketAuth(
    data: PostZendeskConfigsTicketAuthBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigTicketFoundResponse>;
export function postZendeskConfigsTicketAuth(
    data: PostZendeskConfigsTicketAuthBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseZendeskConfigTicketFoundResponse> {
    return request<PostZendeskConfigsTicketAuthBody, never, never>('/zendeskConfigs/ticket/auth', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postZendeskConfigsTicketAuth',
    });
}

export const meta = [
    {
        tags: ['zendesk-config-ticket-controller'],
        path: '/zendeskConfigs/ticket/auth',
        method: 'post',
    },
];
